import { PropsWithChildren, ReactElement } from 'react';
import { LDFlagSet } from 'launchdarkly-node-server-sdk';
import MaintenancePage from '../components/app/maintenance';

const MaintenanceProvider = ({
  children,
  ldFlags,
}: PropsWithChildren<{ children: ReactElement; ldFlags: LDFlagSet }>) => {
  if (ldFlags.valid && ldFlags.shouldShowMaintenancePage)
    return <MaintenancePage />;
  return children;
};

export default MaintenanceProvider;
